export default "__VITE_ASSET__BK9BbH7a__"